import { render, staticRenderFns } from "./unaccess.vue?vue&type=template&id=28fa6ffe&scoped=true"
import script from "./unaccess.vue?vue&type=script&lang=js"
export * from "./unaccess.vue?vue&type=script&lang=js"
import style0 from "./unaccess.vue?vue&type=style&index=0&id=28fa6ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28fa6ffe",
  null
  
)

export default component.exports